import React from 'react'
import { Spin } from 'antd'
import TableRow from './TableRow'
import { canViewStoreName as checkStoreName } from '../../../../services/StorageServices'


const TagBrandTable = ({ loading, error, listTagBrand, reset }) => {
    const canViewStoreName = checkStoreName()
    const _renderTableContent = () => {
        if (listTagBrand.length === 0 && !error) {
            return <tr>
                <td colSpan={7}>No data</td>
            </tr>
        }

        if (!!error) {
            return <tr>
                <td colSpan={7} className='text-danger'>{error}</td>
            </tr>
        }

        return listTagBrand.length > 0 && listTagBrand.map((item) => {
            return <TableRow
                key={item._id}
                item={item}
                reset={reset}
            />
        })
    }

    return (
        <div className='TagBrandTable SkuTable'>
            <Spin tip="Loading..." spinning={loading}>
                <table className="table table-striped">
                    <thead className="TableHead">
                        <tr>
                            {canViewStoreName && <th className="Store">Store</th>}
                            <th className="BrandType">Brand type</th>
                            <th className="MaterialCode">Material code</th>
                            <th className="BrandDetail">Brand detail</th>
                            <th className="Quantity">Quantity</th>
                            <th className="Cost">Cost - Fee</th>
                            <th className="Description">Description</th>
                            <th className="Note">Note</th>
                            <th className="Status">Status</th>
                            <th className="Time">Create - Updated</th>
                            <th className="Action">Action</th>
                        </tr>
                    </thead>
                    <tbody className="TableBody">
                        {_renderTableContent()}
                    </tbody>
                </table>
            </Spin>

        </div>
    )
}

export default TagBrandTable